import {getUserDetailsById} from "api/dashboard.api";
import {useEffect, useState} from "react";
import styled from "styled-components";
import {Modal} from "ui/base/modal/Modal";
import { LoaderComponent, PAGE_HEIGHT } from "ui/base/loading/LoaderComponent";
import {ProfileCard} from "./components/ProfileCard";
import {ReviewCardSlider} from "./components/ReviewCardSlider";

export const UserProfileModal = ({
                                     show,
                                     handleClose,
                                     handleSendMessage,
                                     userId,
                                     isInstructor,
                                 }) => {
    const [userDetails, setUserDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (userId) {
            getUserProfileById(userId);
        }
    }, [userId]);

    const getUserProfileById = (user_id) => {
        setIsLoading(true);
        getUserDetailsById(user_id)
            .then((res) => {
                if (res) setUserDetails(res);
            })
            .catch((err) => {
                console.log("err: ", err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    if (!show || (!isLoading && !userDetails)) return null;

    const filteredReviews =
        userDetails?.user_reviews?.filter((item) => Boolean(item?.review)) ?? [];

    return (
        <Modal
            show={show}
            handleClose={handleClose}
            minHeight={200}
            maxWidth={filteredReviews.length > 0 ? 880 : 420}
        >
            {isLoading ? (
                <LoaderComponent />
            ) : (
                <Section>
                    <GridContainer hasReviews={filteredReviews.length > 0}>
                        <ProfileCell>
                            <ProfileCard
                                userDetails={userDetails}
                                handleSendMessage={handleSendMessage}
                            />
                        </ProfileCell>

                        {filteredReviews.length > 0 && (
                            <ReviewsCell>
                                <ReviewCardSlider reviews={filteredReviews}/>
                            </ReviewsCell>
                        )}
                    </GridContainer>
                </Section>
            )}
        </Modal>
    );
};

const Section = styled.div`
    font-family: var(--font-secondary);
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;

    @media (min-width: 1024px) {
        padding: 1.25rem;
    }
`;


const GridContainer = styled.div`
    display: grid;
    gap: 2rem;
    align-items: start;
    grid-template-columns: 1fr;

    @media (min-width: 1024px) {
        ${({hasReviews}) =>
                hasReviews
                        ? `grid-template-columns: minmax(0,1fr) minmax(0,2fr);`
                        : `grid-template-columns: minmax(0,1fr);`}
    }
`;

const ProfileCell = styled.div`
    min-width: 0;
    height: 100%;
`;

const ReviewsCell = styled.div`
    min-width: 0;
    height: 100%;
`;


